<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="modal-news">
    <div class="modal-header">
      <div class="icon-close" @click="modalClose" />
    </div>
    <div class="modal-content">
      <div class="info-metas">
        <!-- :style="`background-image: url('~${detailsInfo.imgUrl}')`" -->
        <div
          v-if="detailsInfo.photo"
          class="img-container"
          :style="'background-image: url(' + photoBlob + ')'"
        />
        <div v-if="!isMobile" class="extras-wrapper">
          <div class="extra-calendar" :class="!detailsInfo.imgUrl && 'no-top-margin'">
            <div class="icon-calendar" />
            <div class="date-news">{{ detailsInfo.date }}</div>
          </div>
          <div class="tags-wrapper">
            <div v-for="(thesau, j) in parsedCategories" :key="j" class="tag-border">
              <span
                v-for="(saurus, i) in thesau"
                :key="saurus"
                :class="i === thesau.length - 1 ? ' bold' : ''"
              >
                {{ saurus.replace('~', ',') + (i !== thesau.length - 1 ? ' > ' : '') }}
              </span>
            </div>
          </div>
          <a v-if="detailsInfo.url" class="id-button" :href="detailsInfo.url">{{ detailsInfo.textindicator !== '' ? detailsInfo.textindicator : $t('see_id') }}</a>
        </div>
      </div>
      <div class="info-wrapper">
        <span class="new-title">{{ detailsInfo.title }}</span>
        <span v-cms="detailsInfo.desc" class="new-desc" />
      </div>
      <div v-if="isMobile" class="extras-wrapper">
        <div class="extra-calendar" :class="!detailsInfo.imgUrl && 'no-top-margin'">
          <div class="icon-calendar" />
          <div class="date-news">{{ detailsInfo.date }}</div>
        </div>
        <div class="tags-wrapper">
          <div v-for="(thesau, j) in parsedCategories" :key="j" class="tag-border">
            <span
              v-for="(saurus, i) in thesau"
              :key="saurus"
              :class="i === thesau.length - 1 ? ' bold' : ''"
            >
              {{ saurus.replace('~', ',') + (i !== thesau.length - 1 ? ' > ' : '') }}
            </span>
          </div>
        </div>
        <a v-if="detailsInfo.url" class="id-button" :href="detailsInfo.url">{{ detailsInfo.textindicator !== '' ? detailsInfo.textindicator : $t('see_id') }}</a>
      </div>
    </div>
    <div class="modal-footer">
      <div v-if="!firstNew" class="op-wrap" @click="findPrevNew">
        <div class="icon-arrow-blue" />
        <div>{{ $t('notice_prev') }}</div>
      </div>
      <div />
      <div v-if="!lastNew" class="op-wrap" @click="findNextNew">
        <div>{{ $t('notice_next') }}</div>
        <div class="icon-arrow-blue rotated" />
      </div>
    </div>
  </div>
</template>

<script>
import { vCmsHtml as cms, getCmsResourceBlob } from '@/services/graphql'
/**
 * Renders a modal with news info
 * @example [none]
 */
export default {
  name: 'ModalNewsDetail',
  directives: { cms },
  props: {
    /**
     * Function for close the modal
     */
    modalClose: {
      type: Function,
    },
    detailsInfo: {
      type: Object,
    },
    findOtherNew: {
      type: Function,
    },
    firstNew: {
      type: Boolean,
    },
    lastNew: {
      type: Boolean,
    },
  },
  data() {
    return {
      photoBlob: '',
    }
  },
  computed: {
    parsedCategories() {
      console.log(this.detailsInfo);
      return this.detailsInfo.category.map(el => el.split(','))
    },
  },
  watch: {
    'detailsInfo.photo': {
      immediate: true,
      handler(val) {
        if (val) {
          getCmsResourceBlob(val)
            .then(blob => {
              this.photoBlob = URL.createObjectURL(blob)
            })
            .catch(ex => {
              console.log(ex)
            })
        }
      },
    },
  },
  methods: {
    findNextNew() {
      this.findOtherNew('next', this.detailsInfo)
    },
    findPrevNew() {
      this.findOtherNew('prev', this.detailsInfo)
    },
  },
}
</script>

<style lang="stylus" scoped>
.modal-news
  display: flex
  flex-direction: column
  height: 100%
  padding: vw(50px) vw(100px)
  width: 100%

  .mobile &
    padding: vw(20px)

  .modal-header
    margin-bottom: vw(30px)

  .modal-content
    display: flex
    flex: 1 1 0%
    gap: vw(30px)
    justify-content: space-between
    overflow: hidden
    padding: vw(10px) vw(30px) vw(20px)
    padding: 0

    .mobile &
      flex-direction: column
      gap: vw(15px)
      overflow-y: auto

    .info-wrapper
      flex: 1 1 0%
      overflow-y: auto
      padding-right: vw(10px)

      .mobile &
        overflow: visible

      .new-title
        m-font-size(24, 30)
        font-weight: 600
        margin-bottom: vw(15px)

      .new-desc
        m-font-size(16, 25)
        color: $grey
        font-weight: 400
        
        >>> a
          color: $corporate_color
          text-decoration: none

          &:hover
            color: $corporate_color
            cursor: pointer

    .info-metas
      display: flex
      flex: 0 0 vw(175px)
      flex-direction: column

    .extras-wrapper
      .no-top-margin
        margin: 0 0 vw(15px) !important

      .id-button
        m-font-size(16, 22)
        color: $corporate_color
        font-weight: 400

      .extra-calendar
        align-items: center
        display: flex
        margin: vw(15px) 0

        .icon-calendar
          m-icon("calendar", 16)
          margin-right: vw(5px)

        .date-news
          m-font-size(12, 16)
          color: $grey-dark
          font-weight: 400
          margin-top: 0.1em

      .tags-wrapper
        display: flex
        flex-wrap: wrap
        gap: vw(10px)
        margin-bottom: vw(15px)

        .tag-border
          border: 1px solid $corporate_color_light
          border-radius: 20px
          display: flex
          gap: vw(2px)
          padding: vw(4px) vw(12px)

          span
            m-font-size(12, 16)
            color: $grey-dark
            font-weight: 400
            white-space: nowrap

            &.bold
              color: black
              font-weight: 600

  .img-container
    background-position: center center
    background-repeat: no-repeat
    background-size: cover
    height: vw(175px)
    margin-bottom: vw(15px)
    width: vw(175px)

    .mobile &
      width: 100%

  .modal-footer
    border-top: 1px solid $grey-grey
    display: flex
    justify-content: space-between
    margin-top: vw(50px)

    .mobile &
      margin-top: vw(30px)

    .op-wrap
      m-font-size(15, 19)
      align-items: center
      color: $corporate_color
      cursor: pointer
      display: flex
      gap: vw(5px)
      height: vw(50px)

      &:hover
        .icon-arrow-blue
          transform: translateX(-5px)

          &.rotated
            transform: translateX(5px) rotate(180deg)

    .icon-arrow-blue
      m-icon("arrow-back-blue", 24, $corporate_color, false)
      transition: transform 0.25s ease-in-out

      &.rotated
        transform: rotate(180deg)

  .modal-header
    height: vw(32px)
    position: relative

    .icon-close
      m-icon("modal-close", 32, $grey-dark)
      cursor: pointer
      position: absolute
      right: 0
      top: 0
</style>
